import { render } from "./stronaZarobki.vue?vue&type=template&id=e49a0264&scoped=true"
import script from "./stronaZarobki.vue?vue&type=script&lang=js"
export * from "./stronaZarobki.vue?vue&type=script&lang=js"

import "./stronaZarobki.vue?vue&type=style&index=0&id=e49a0264&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e49a0264"]])

export default __exports__